module.exports = __webpack_public_path__ + "images/dingtalk/icon-feedback-2-0f151f3d2971d78c6c7ff3e7af9453c8.png";